{
  "titles": {
    "appointmentDetailsHaveChanged": "Appointment details have changed",
    "appointmentScheduled": "Appointment scheduled",
    "appointmentConfirmed": "Appointment confirmed",
    "appointmentRequested": "Appointment requested",
    "missedAppointment": "Missed appointment",
    "recurringAppointmentSeriesCreated": "Recurring appointment series created",
    "truckArrivedAtFacility": "Truck arrived at facility",
    "appointmentIsInProgressAtFacility": "Appointment is in progress at facility",
    "appointmentRescheduled": "Appointment rescheduled",
    "appointmentCompleted": "Appointment completed",
    "appointmentCancelled": "Appointment cancelled",
    "appointmentTagged": "Appointment tagged",
    "assetReadyForPickup": "Asset ready for pickup"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "Appointment details have changed",
    "appointmentScheduled": "Appointment scheduled at {orgName} - {warehouseName}",
    "appointmentConfirmed": "Appointment confirmed at {orgName} - {warehouseName}",
    "appointmentRequested": "Appointment requested at {orgName} - {warehouseName}",
    "missedAppointment": "Missed appointment at {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "Recurring appointment series has been created",
    "truckArrivedAtFacility": "Truck arrived at {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "Appointment is in progress at {orgName} - {warehouseName}",
    "appointmentRescheduled": "Appointment rescheduled at {orgName} - {warehouseName}",
    "appointmentCompleted": "Appointment completed at {orgName} - {warehouseName}",
    "appointmentCancelled": "Appointment cancelled with {orgName} - {warehouseName}",
    "appointmentTagged": "Appointment tagged as {tagName} - {warehouseName}",
    "assetReadyForPickup": "Ready for Pickup - Container {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "Please check location, date, time and all details below.",
    "appointmentScheduled": "Please check location, date, time and all details below.",
    "appointmentConfirmed": "Please check location, date, time and all details below.",
    "appointmentRequested": "Please wait for warehouse confirmation.",
    "missedAppointment": "Carrier did not show for the appointment.",
    "recurringAppointmentSeriesCreated": "Please check the details of the recurring appointment below.",
    "truckArrivedAtFacility": "Check the status and appointment details below.",
    "appointmentIsInProgressAtFacility": "Check the status and appointment details below.",
    "appointmentRescheduled": "Check the status and appointment details below.",
    "appointmentCompleted": "Check the status and appointment details below.",
    "appointmentCancelled": "Please check all details and reason for cancellation.",
    "appointmentTagged": "Please check the tag name and information below.",
    "assetReadyForPickup": "An asset at your facility is ready for pickup."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "View Appointment",
    "appointmentScheduled": "View Appointment",
    "appointmentConfirmed": "View Appointment",
    "appointmentRequested": "View Appointment",
    "missedAppointment": "View Appointment",
    "recurringAppointmentSeriesCreated": "View Original Appointment",
    "truckArrivedAtFacility": "View Appointment",
    "appointmentIsInProgressAtFacility": "View Appointment",
    "appointmentRescheduled": "View Appointment",
    "appointmentCompleted": "View Appointment",
    "appointmentCancelled": "View Appointment",
    "appointmentTagged": "View Appointment",
    "assetReadyForPickup": "View Appointment"
  },
  "descriptions": {
    "appointmentTagged": "Use Appointment Tags setting to enable tags individually"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "Schedule Pickup",
      "idLabel": "Confirmation Number",
      "ownedByLabel": "Owned by:",
      "pickupScheduledForLabel": "Pickup scheduled for:",
      "noPickupScheduledLabel": "No pickup appointment scheduled",
      "storeLabel": "Store",
      "openInGoogleMapsLabel": "Open in Google Maps",
      "appointmentDetailsLabel": "Appointment Details",
      "loadTypeLabel": "Load Type",
      "warehouseInstructionsLabel": "Warehouse Instructions",
      "amenitiesLabel": "Amenities available",
      "ppeRequirementsLabel": "PPE & other requirements",
      "dockDoorLabel": "Dock Door",
      "dockInstructionsLabel": "Dock Instructions",
      "carrierContactLabel": "Carrier Contact"
    }
  }
}
